import { render, staticRenderFns } from "./loufengExperReort.vue?vue&type=template&id=201f4c8c&scoped=true&"
import script from "./loufengExperReort.vue?vue&type=script&lang=js&"
export * from "./loufengExperReort.vue?vue&type=script&lang=js&"
import style0 from "./loufengExperReort.vue?vue&type=style&index=0&id=201f4c8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201f4c8c",
  null
  
)

export default component.exports